import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CATEGORIES = ["All", "Weddings", "Reception", "Festive", "Corporate", "Birthday"];

const items = [
  {
    cat: "Weddings",
    src: "https://test.00abc.xyz/shreeevents/wp-content/uploads/2026/05/wedding.webp",
    label: "Traditional Wedding Mandap",
  },
  {
    cat: "Festive",
    src: "https://test.00abc.xyz/shreeevents/wp-content/uploads/2026/05/garba-1.png",
    label: "Navratri & Garba Nights",
  },
  {
    cat: "Reception",
    src: "https://test.00abc.xyz/shreeevents/wp-content/uploads/2026/05/reception.webp",
    label: "Reception Stage Décor",
  },
  {
    cat: "Weddings",
    src: "https://test.00abc.xyz/shreeevents/wp-content/uploads/2026/05/sr_gallery1.webp",
    label: "Floral Mandap Setup",
  },
  {
    cat: "Reception",
    src: "https://test.00abc.xyz/shreeevents/wp-content/uploads/2026/05/sr_gallery2.webp",
    label: "Elegant Stage Design",
  },
  {
    cat: "Festive",
    src: "https://test.00abc.xyz/shreeevents/wp-content/uploads/2026/05/sr_gallery3.webp",
    label: "Festive Celebration",
  },
  {
    cat: "Weddings",
    src: "https://test.00abc.xyz/shreeevents/wp-content/uploads/2026/05/sr_gallery4.webp",
    label: "Wedding Décor Detail",
  },
  {
    cat: "Reception",
    src: "https://test.00abc.xyz/shreeevents/wp-content/uploads/2026/05/sr_gallery5.webp",
    label: "Reception Ambience",
  },
  {
    cat: "Festive",
    src: "https://test.00abc.xyz/shreeevents/wp-content/uploads/2026/05/sr_gallery6.png",
    label: "Cultural Setup",
  },
  {
    cat: "Corporate",
    src: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=1200&q=80",
    label: "Corporate Gala · Vadodara",
  },
  {
    cat: "Birthday",
    src: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=1200&q=80",
    label: "Milestone Birthday",
  },
  {
    cat: "Birthday",
    src: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1200&q=80",
    label: "Theme Party Setup",
  },
];

export default function Gallery() {
  const [filter, setFilter] = useState("All");
  const filtered = filter === "All" ? items : items.filter((i) => i.cat === filter);

  return (
    <section id="gallery" className="relative section-pad" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12"
        >
          <div className="max-w-xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold" />
              <span className="text-xs uppercase tracking-[0.3em] text-gold font-medium">
                Our Beautiful Celebrations
              </span>
            </div>
            <h2
              className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
              data-testid="gallery-heading"
            >
              A glimpse of <span className="italic text-gold-gradient">our work</span>
            </h2>
            <p className="mt-4 text-ivory/60 text-base font-light">
              Every event we design is created with a unique theme, thoughtful styling
              and a personal touch.
            </p>
          </div>
          <div className="flex flex-wrap gap-2" data-testid="gallery-filters">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                data-testid={`gallery-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-4 py-2 rounded-full text-xs tracking-[0.15em] uppercase border transition-all duration-300 ${
                  filter === c
                    ? "bg-gold text-ink border-gold"
                    : "border-white/15 text-ivory/65 hover:border-gold/50 hover:text-gold"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </motion.div>

        <motion.div
          layout
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 auto-rows-[260px]"
        >
          <AnimatePresence mode="popLayout">
            {filtered.map((it, i) => (
              <motion.div
                layout
                key={it.src + i}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.45, delay: (i % 6) * 0.04 }}
                className={`relative overflow-hidden rounded-2xl group cursor-pointer border border-white/5 ${
                  i % 5 === 0 ? "sm:row-span-2 sm:col-span-1" : ""
                }`}
                data-testid={`gallery-item-${i}`}
              >
                <img
                  src={it.src}
                  alt={it.label}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent opacity-90 group-hover:opacity-95 transition-opacity" />
                <div className="absolute inset-x-0 bottom-0 p-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                  <div className="text-[10px] uppercase tracking-[0.3em] text-gold/90 mb-1">
                    {it.cat}
                  </div>
                  <div className="font-serif text-xl text-ivory leading-tight">{it.label}</div>
                </div>
                <div className="absolute top-4 right-4 w-8 h-8 border-t border-r border-gold/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
}
